import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { useCatalog } from '../../context/CatalogContext';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './HeroBanner.css';

const HeroBanner = () => {
  const { banners } = useCatalog();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    pauseOnHover: true,
    arrows: true
  };

  return (
    <section className="hero-banner">
      <Slider {...settings}>
        {banners.map(banner => (
          <div key={banner.id} className="banner-slide">
            <div 
              className="banner-content"
              style={{ 
                backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${banner.image})`,
                backgroundColor: banner.bgColor
              }}
            >
              <div className="banner-text">
                <span className="banner-subtitle">{banner.subtitle}</span>
                <h2 className="banner-title">{banner.title}</h2>
                <Link to={banner.link} className="btn btn-primary banner-btn">
                  {banner.buttonText}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default HeroBanner;
